export const LogoMark = ({ size = 34 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#0B0F12" stroke="rgba(255,255,255,0.14)" />
        <path d="M11 43 L32 22 L53 43" stroke="#F59E0B" strokeWidth="5" strokeLinecap="square" />
        <path d="M32 22 L32 7" stroke="#F8FAFC" strokeWidth="5" strokeLinecap="square" />
        <path d="M24 14.5 L40 14.5" stroke="#F8FAFC" strokeWidth="5" strokeLinecap="square" />
    </svg>
);

export const Logo = ({ dark = true }) => (
    <span className="flex items-center gap-3">
        <LogoMark />
        <span className="flex flex-col leading-none">
            <span className="font-display font-bold uppercase tracking-wide text-[15px] text-[#F8FAFC]">
                One God Roofing
            </span>
            <span className="font-mono2 text-[9px] uppercase tracking-[0.28em] text-[#94A3B8] mt-1">
                Sunyani · Ghana
            </span>
        </span>
    </span>
);

export default Logo;
